import { AxiosResponse } from "axios";
import React, { useContext, useEffect, useState } from "react";
import { connect } from "react-redux";
import { Field, getFormValues, InjectedFormProps, reduxForm } from "redux-form";
import { ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";
import { toast } from "react-toastify";
import Service from "../../services";
import { TextField } from "common-fields";
import SelectField from "../../commonfields/SelectField";
import SpinnerModel from "../../commonfields/SpinnerModel";
import { BankUserContext } from "../../bankUserContext";


const UpdateUserForm: React.FC<any & InjectedFormProps<Record<string, unknown>, any>> = (
  props: any
) => {
  const service = new Service();
  const [getRolesByOrgIdMap, setGetRolesByOrgIdMap] = useState<[] | []>([]);
  const [loader, setLoader] = useState(false);
  const context = useContext(BankUserContext);
  //const orgId=APP_Config().REACT_APP_ORG_ID;
  console.log([props?.formValues?.roles], "users")

  const getRolesCall = () => {
    const payload = {
      "screen": "LandingPage",

      "sections": "getUserRoles",

      "orgId": context.bankuserDetails?.organization.orgId,
    }
    service
      .getLeadsData(payload)
      .then((response: AxiosResponse) => {
        setGetRolesByOrgIdMap(response.data);
      })
      .catch((error: any) => {
        toast.error(error.response.data.Errormessage);
      });
  };
  useEffect(() => {
    getRolesCall(); //orgId should be dynamic
  }, []);

  const CreateUserCall = (body: any) => {
    setLoader(true)
    // service
    //   .createUser(body)
    //   .then((response: AxiosResponse) => {
    //     if (response.status === 200) {
    //       setLoader(false);
    //       toast.success(response.data);
    //       props.getAllUsersByOrgId(orgId, " ");
    //       props.closeToggle();
    //     }
    //     else{
    //       setLoader(false);
    //       toast.error("something went wrong")
    //     }
    //   })
    //   .catch((error) => {
    //     setLoader(false);
    //     toast.error(error.response.data.Errormessage);
    //   });
  };

  const updateUser = (body: any) => {
    setLoader(true);
    service
      .updateAdminUsers(body)
      .then((response: AxiosResponse) => {
        setLoader(false);
        toast.success(response.data);
        props.getAllUsersByOrgId();
        props.closeToggle();
      })
      .catch((error) => {
        setLoader(false);
        toast.error(error?.response?.data?.Errormessage);
      });
  };

  const handleFormSubmit = () => {
    const body = {
      userId: props?.user?.userId ? props?.user?.userId : undefined,
      firstName: props?.formValues?.firstName,
      lastName: props?.formValues?.lastName,
      email: props?.formValues?.email,
      phone: props?.formValues?.phone,
      roles: [props?.formValues?.roles],
    };
    if (props?.user?.userId) {
      updateUser(body);
    } else {
      CreateUserCall(body);
    }
  };

  return (
    <>
      <ModalHeader toggle={() => props?.closeToggle()}>
        {props.user?.userId ? <>Update User</> : <> Create New User</>}
      </ModalHeader>
      <ModalBody>
        <form className="form-group">
          <Field
            component={TextField}
            isRequired="true"
            name={"firstName"}
            label={"First Name"}
            HelpText={"firstName"}
            type="text"
          // values={}
          />

          <Field
            component={TextField}
            isRequired="true"
            name={"lastName"}
            label={"Last Name"}
            HelpText={"lastName"}
            type="text"
          />
          <Field
            component={TextField}
            isRequired="true"
            name={"email"}
            label={"Email"}
            HelpText={"email"}
            type="email"
          />
          <Field
            component={SelectField}
            isRequired="true"
            name={"roles"}
            label={"Roles"}
            HelpText={"roles"}
            type="text"
            values={getRolesByOrgIdMap}
          //disabled={props?.user?.roles === "CLIENT"}
          />
          <Field
            component={TextField}
            isRequired="true"
            name={"phone"}
            label={"Phone Number"}
            HelpText={"phone"}
            type="text"
          // normalize={normalizePhone}
          />
        </form>
        {loader ? <SpinnerModel value={""} color={"primary"} size={""} type={"border"} /> : null}
      </ModalBody>
      <ModalFooter>
        <Button
          color="danger"
          disabled={props.invalid || props.pristine}
          onClick={() => handleFormSubmit()}
        >
          {props?.user?.userId ? <>Update</> : <>Create</>}
        </Button>{" "}
        <Button onClick={() => props?.closeToggle()}>Cancel</Button>
      </ModalFooter>
    </>
  );
};

export default connect((state: any, props: any) => {
  return {
    initialValues: {
      firstName: props?.user?.firstName,
      lastName: props?.user?.lastName,
      email: props?.user?.email,
      phone: props?.user?.phone,
      roles: props?.user?.role[0]?.toString(),
    },
    formValues: getFormValues("UpdateUserForm")(state),
  };
})(
  reduxForm<Record<string, unknown>, any>({
    form: "UpdateUserForm",
    enableReinitialize: true,
    //validate,
  })(UpdateUserForm)
);
